import React, {Component} from 'react';

import _ from 'lodash';
import moment from 'moment';

import ModeloProductos from './ModeloProductos.jsx';

import { Temp, TempHum, SigatokaRiesgo, TempHumPre, MH, DPV } from './ModeloGraph.js';

import type { T_InfoWeek } from './DialogSensorCultivoUPL.jsx';
import type { T_AlertasActivasUPL } from './DialogSensorCultivoUPL.jsx';

import './css/Modelo.css';

const
  tooltip = require('../src/css/img/tooltip.png'),
	warning_sign_red = require('./css/img/warning-01.png'),
  warning_sign_yellow = require('./css/img/warning-02.png'),
  or_sign = require('./css/img/control_fito/signo_or.png')
;


type T_ModeloProps = {
	alertas_data: Array<T_AlertasActivasUPL>,
	enfermedad: string,
	data: Array<T_Info>,
  title: string,
  week_data: Array<T_InfoWeek>,
  app:App,
  path: string
}

export default class Modelo extends Component<T_ModeloProps> {
  constructor(props) {
    super(props);

    this.state = {
      buffer: []
    };
  }

  async componentDidMount() {
    const {app, cultivo, title }= this.props;
    await fetch('./dosis.json')
      .then(res => res.json())
      .then(data => this.setState({ buffer: data[cultivo][title].buffer }))
      .catch(error => console.log(error))
    ;
  }

  calcularRiesgo = (data) => {
    const semanaData = data.slice((data.length) - 181, (data.length));

    let
      infeccion = 0,
      contador = 0,
      valores = [],
      fechas = [],
      temp_promedio = 0,
      humedad_promedio = 0,
      contador_promedio = 0,
      pre_acumulada = 0,
      riesgo_maximo = 0,
      numero_alertas = 0
    ;

    for(let i = semanaData.length - 1; i > 1; i--){
      contador++
      if(semanaData[i].pre > 0 || semanaData[i].temp > 18 || semanaData[i].hum > 90 || semanaData[i].mh === 1){
        if(semanaData[i].temp >= 27 && semanaData[i].temp <= 30){
          infeccion = infeccion + 2
        }else{
          if(infeccion > 0){
            infeccion--
          }
        }
      }else{
        infeccion = 0
      }
      if(contador > 11){
        valores.push(infeccion)
        fechas.push(semanaData[i].fecha)
        temp_promedio = semanaData[i].temp + temp_promedio
        humedad_promedio = semanaData[i].hum + humedad_promedio
        pre_acumulada = pre_acumulada + semanaData[i].pre
        contador_promedio++
        if(infeccion > 0 ){
          numero_alertas++
        }
        if(riesgo_maximo<infeccion){
          riesgo_maximo = infeccion
        }
      }
    }

    humedad_promedio = humedad_promedio/contador_promedio
    temp_promedio = temp_promedio/contador_promedio
  
    return valores.map((valor, v) => ({ riesgo: valor, pre: parseFloat(semanaData[semanaData.length - 1 - v].pre), fecha: moment(fechas[v]).format('YYYY-MM-DD HH:mm')}));
  }

	render_graph(title: string) {
    const
      { buffer } = this.state,
      { alertas_data, enfermedad, data, week_data } = this.props
    ;

		if (title ==='sigatoka_negra') {
      const dataRiesgo = this.calcularRiesgo(data);

			return (
        <div>
          <div className="model-recomendacion graph">
            <div className="model-recomendacion-title">
              <p>Variables Metereológicas</p>
              <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
                <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
                <span
                  className="tooltip-text tooltip-bottom"
                  style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
                >
                  <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
                </span>
              </div>
            </div>
            <div>
              <TempHum
                data={week_data.data}
                buffer={buffer}
                sigatoka={true}
              />
            </div>
          </div>
          <div className="model-recomendacion graph">
            <div className="model-recomendacion-title">
              <p>Riesgo de {_.startCase(enfermedad)}</p>
              <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
                <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
                <span
                  className="tooltip-text tooltip-bottom"
                  style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
                >
                  <p style={{ lineHeight: '17px' }}>Muestra la evolución del riesgo de infección de la enfermedad o plaga.</p>
                </span>
              </div>
            </div>
            <div>
              <SigatokaRiesgo
                data={dataRiesgo}
              />
            </div>
          </div>
        </div>
			);
		} else if (
      title === 'moco_bacteriano'    ||
      title === 'palomilla_papa'     ||
      title === 'palomilla_manzano'  ||
      title === 'trozador'           ||
      title === 'cogollero'          ||
      title === 'gusano_chile'       ||
      title === 'gusano_soldado_papa'||
      title === 'guzano_alambre_maiz'||
      title === 'elotero'            ||
      title === 'gallina_ciega_maiz' ||
      title === 'diabrotica_raiz'    ||
      title === 'diabrotica_follaje' ||
      title === 'afidos_maiz'        ||
      title === 'trips_maiz'         ||
      title === 'mosca_estigma_maiz' || 
      title === 'paratrioza'
    ) {
      return (
        <div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
          <Temp
            data={week_data.data}
            buffer={buffer}
          />
        </div>
      );
    } else if (
      title === 'alternaria_papa'    ||
      title === 'cenicilla_pimiento' 
    ) {
      return (
				<div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
					<div>
						<Temp
							data={week_data.data}
              buffer={buffer}
						/>
					</div>
					<div>
						<MH
							data={week_data.data}
						/>
					</div>
				</div>
      );
    } else if (
      title === 'fusarium_agave'      ||
      title === 'fusarium_maiz'
    ) {
      return (
				<div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
					<div>
						<Temp
							data={week_data.data}
              buffer={buffer}
						/>
					</div>
					<div>
						<DPV
							data={week_data.data}
              buffer={buffer}
						/>
					</div>
				</div>
      );
    } else if (
      title === 'pudricion_cogollo'          ||
      title === 'tizon_tardio_papa'          ||
      title === 'tizon_foliar_maiz'          ||
      title === 'pulgones_chile'             ||
      title === 'aranha_roja_fresa'          ||
      title === 'antracnosis_aguacate'       ||
      title === 'cenicilla_manzano'          ||
      title === 'corynespora'                ||
      title === 'cenicilla_tomate'           ||
      title === 'erwinia'                    ||
      title === 'tizon_tardio_tomate'        ||
      title === 'blackdot_antracnosis_papa'  ||
      title === 'xanthomonas_pimiento'       ||
      title === 'acaro_manzano'              ||
      title === 'aranha_roja_tomate'         ||
      title === 'pulgones_papa'              ||
      title === 'acaro_blanco_papa'          ||
      title === 'acaro_maiz'                 ||
      title === 'phythophtora_palmivora'     ||
      title === 'phythophtora_cinnamomi'     ||
      title === 'moho_blanco_papa'           ||
      title === 'acaro_tomate'               ||
      title === 'corynespora_melon'           
    ) {
      return (
        <div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
          <TempHum
            data={week_data.data}
            buffer={buffer}            
            sigatoka={false}
          />
        </div>
      );
    } else if (
      title === 'xanthomonas_tomate'    ||
      title === 'botrytis_fresa'        ||
      title === 'tizon_fuego_manzano'   ||
      title === 'botrytis_pimiento'     ||
      title === 'roya_maiz'             ||
      title === 'cenicilla_pepino'      ||
      title === 'cenicilla_chile'       ||
      title === 'dydimella'             ||
      title === 'dydimella_melon'             ||
      title === 'stemphyllium_tomate'   ||
      title === 'cenicilla_melon'
    ) {
      return (
				<div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
					<div>
						<TempHum
							data={week_data.data}
              buffer={buffer}
              sigatoka={false}
						/>
					</div>
					<div>
						<MH
							data={week_data.data}
						/>
					</div>
				</div>
      );
    } else if (
      title === 'trips'                     ||
      title === 'barrenador_cana'           ||
      title === 'mosca_pinta'               ||
      title === 'picudo_banano'             ||
      title === 'picudo_agave'              ||
      title === 'picudo_pimiento'           ||
      title === 'picudo_chile'              ||
      title === 'barrenador_nogal'          ||
      title === 'barrenador_pinha'          ||
      title === 'mosca_blanca_papa'         ||
      title === 'mosca_blanca_pepino'       ||
      title === 'mosca_blanca_tomate'       ||
      title === 'pierna_negra_papa'         ||
      title === 'acaro_cristalino_aguacate' ||
      title === 'acaro_cafe_aguacate'
    ) {
			return (
        <div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
          <TempHumPre
            data={week_data.data}
            buffer={buffer}
          />
        </div>
			);
		} else if (
      title === 'mildiu_pepino'   ||
      title === 'mildiu_melon'    ||
      title === 'cenicilla_fresa' ||
      title === 'cenicilla_nogal' ||
      title === 'mancha_vellosa_nogal'
    ) {
      return (
				<div className="model-recomendacion graph">
          <div className="model-recomendacion-title">
            <p>Variables Metereológicas</p>
            <div className="toolTip" style={{ left: alertas_data.length > 0 ? '94%' : '97%', bottom: '105%', padding: '0px', width: '21px' }}>
              <img src={tooltip} style={{ width: '100%' }} alt="" className="tooltip-icon" />
              <span
                className="tooltip-text tooltip-bottom"
                style={{ left: '-180%', fontFamily: 'Raleway', fontWeight: 'bolder' }}
              >
                <p style={{ lineHeight: '17px' }}>Muestra la evolución de las principales variables metereológicas asociadas a la ocurrencia de la enfermedad o plaga.</p>
              </span>
            </div>
          </div>
					<div>
						<TempHumPre
							data={week_data.data}
              buffer={buffer}
						/>
					</div>
					<div>
						<MH
							data={week_data.data}
						/>
					</div>
				</div>
      );
    }
  }
  
	render() {
		const
      { app, cultivo, alertas_data, enfermedad, title, superficie } = this.props,
      has_alertas = _.find(alertas_data, data => data.enfermedad === enfermedad),
      has_alertas_preventiva = _.find(alertas_data, data => data.recom === 'preventiva'),
      has_alertas_curativa = _.find(alertas_data, data => data.recom === 'curativa')
    ;

		return (
			<div className='result-container'>
				<div className="result-graph" style={{ width: !! has_alertas ? '50%' : '100%' }}>
					{ this.render_graph(title) }
				</div>
        {!! has_alertas &&
          <div style={{ display: 'block', width: '50%', textAlign: 'left' }}>
            <div style={{ contain: 'content', margin: '10px' }}>
              <div className="model-recomendacion">
                <div className="model-recomendacion-title">
                  <p>Alertas</p>
                </div>
                <div className="alertasUPL-list">
                  {alertas_data.map((alerta_data, ad) => {
                    if (alerta_data.enfermedad === enfermedad) {
                      return (
                        alerta_data.recom === 'preventiva' ?
                          <div key={ad} className="alertasUPL-listBlock" title="Ver recomendación">
                            <img src={warning_sign_yellow} className="warning-signUPL" alt="warning_sing_yellow" style={{ margin: title === 'barrenador' ? '10px 5px 10px 20px' : '10px 5px 10px 30px' }}/>
                            <span>Alerta <b>Preventiva</b> de <b>{_.startCase(enfermedad)}</b> {moment(alerta_data.fecha).format('L')}</span>
                          </div>
                          :
                          <div key={ad} className="alertasUPL-listBlock" title="Ver recomendación">
                            <img src={warning_sign_red} className="warning-signUPL" alt="warning_sing_red" style={{ margin: title === 'barrenador' ? '10px 5px 10px 20px' : '10px 5px 10px 30px' }}/>
                            <span>Alerta <b>Curativa</b> de <b>{_.startCase(enfermedad)}</b> {moment(alerta_data.fecha).format('L')}</span>
                          </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            </div>
            {/* {title === 'sigatoka_negra' ? 
              this.render_sigakota_negra() 
                : */}
              <ModeloProductos
                cultivo={cultivo}
                modelo={title}
                preventiva={!!has_alertas_preventiva}
                curativa={!!has_alertas_curativa}
                app={app}
                superficie = {superficie}
                path={this.props.path}
              />
            {/* } */}
          </div>
        }
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/Modelo.jsx